import React, { useState, useEffect } from "react";
import { FaCog, FaSearch, FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "utils/constant";
import { PiSquareSplitVerticalFill } from "react-icons/pi";
import { AiFillPlusCircle } from "react-icons/ai";
import { add } from "date-fns";
import { height } from "@mui/system";
import { FaLock } from "react-icons/fa";
import {
  MdAccountBalanceWallet,
  MdDiversity3,
  MdFoundation,
  MdHelp,
  MdOutlineInventory2,
  MdOutlinePeopleAlt,
  MdOutlineShoppingCart,
  MdOutlineSupportAgent,
  MdDescription,
} from "react-icons/md";
import { Clock, Users } from "lucide-react";
import AccountModal from "components/AccountModal";
import Microinteraction from "../../assets/Microinteraction.svg";
import { UserAPI, SubscriptionAPI } from "api/dashboard/service";

const LeftSidebar = ({
  onNewProjectClick,
  organizationId,
  showInvitationsForm,
  handleOrganizationDetailsClick,
  currentTab,
  setCurrentTab,
}) => {
  const [members, setMembers] = useState([]);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [userData, setUserData] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const [subscriptionName, setSubscriptionName] = useState("");
  const isSubscribed = !!subscriptionName;

  useEffect(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    if (saved !== null) {
      setIsCollapsed(saved === "true");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", isCollapsed ? "true" : "false");
  }, [isCollapsed]);
  const handleLogout = async () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        refresh: localStorage.getItem("refresh"),
      }),
    };
    try {
      const response = await fetch(
        `${BASE_URL}/token/blacklist/`,
        requestOptions
      );
      const data = await response.json();
      // console.log(data);
      if (data?.code !== "token_not_valid") {
        localStorage.clear();
        navigate("/login");
      } else {
        console.log("Token not valid");
        localStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getUserDetails = async () => {
    const accessToken = localStorage.getItem("access");
    if (accessToken) {
      // const response = await fetch(`${BASE_URL}/auth/user-details-of-user/`, {
      //   method: "GET",
      //   headers: new Headers({
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${accessToken}`,
      //   }),
      // });
      const data = await UserAPI.getUserDetails();
      if (data?.status) {
        setUserData(data?.data);
        setIsOwner(data?.data?.profession === "owner");
      } else {
        // navigate("/profession");
        return;
      }
    }
  };

  const handleMyOrgClick = () => {
    handleOrganizationDetailsClick();
  };

  const getOrganizationMembers = async () => {
    try {
      const accessToken = localStorage.getItem("access");
      const organization = localStorage.getItem("organization");
      const organizationId = JSON.parse(organization)?.id;
      if (accessToken && organizationId) {
        const response = await fetch(
          `${BASE_URL}/org/organization/${organizationId}/members/`,
          {
            method: "GET",
            headers: new Headers({
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            }),
          }
        );
        const data = await response.json();
        if (data.status) {
          // console.log("Organization members:", data.data);
          setMembers(data.data);
        }
      }
    } catch (error) {
      console.log("Error fetching organization members:", error);
    }
  };
  useEffect(() => {
    getOrganizationMembers();
  }, [organizationId, showInvitationsForm]);

  useEffect(() => {
    // console.log("isOwner", localStorage.getItem("isOwner"));

    setIsOwner(localStorage.getItem("isOwner") === "true");
  }, [localStorage.getItem("isOwner")]);

  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        if (!organizationId) {
          setSubscriptionName("");
          return;
        }
        const response = await SubscriptionAPI.checkUserSubscription(
          organizationId
        );
        if (
          response?.status &&
          response?.data?.active_flag &&
          response?.data?.subscription_name
        ) {
          setSubscriptionName(String(response.data.subscription_name).trim());
        } else {
          // no active subscription
          setSubscriptionName("");
        }
      } catch (error) {
        setSubscriptionName("");
      }
    };
    fetchSubscription();
  }, [organizationId]);

  const MenuItem = ({ tab, label, Icon, disabled }) => (
    <div
      className={`${currentTab === tab && !disabled
        ? ""
        : "hover:bg-gray-100 hover:rounded-lg"
        } ${disabled ? "opacity-50" : ""}`}
      title={isCollapsed ? label : undefined}
      onClick={() => {
        if (!disabled) setCurrentTab(tab);
      }}
      style={{
        ...styles.menuItem,
        cursor: disabled ? "not-allowed" : "pointer",
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      {currentTab === tab && !disabled && !isCollapsed ? (
        <div className="h-[50px] w-[5px] bg-[#3B0069] rounded-r-xl" />
      ) : null}
      <div
        className={`flex items-center w-full ${isCollapsed ? "justify-center" : "gap-2"}`}
        style={{
          marginLeft:
            isCollapsed || (currentTab === tab && !disabled) ? "0px" : "16px",
        }}
      >
        <Icon
          className={`${currentTab === tab && !disabled
            ? "text-[#3B0069]"
            : "text-[#A3A3A3]"
            }`}
          size={22}
        />
        {!isCollapsed && (
          <span
            className={`${currentTab === tab && !disabled
              ? "text-[#3B0069] font-medium"
              : "text-[#A3A3A3]"
              } text-[15px]`}
          >
            {label}
          </span>
        )}
        {disabled && !isCollapsed && (
          <FaLock size={14} className="text-[#A3A3A3] ml-auto mr-4" />
        )}
      </div>
    </div>
  );
  return (
    <div
      style={{ ...styles.sidebar, width: isCollapsed ? "64px" : styles.sidebar.width }}
      className="relative flex flex-col justify-between pb-12"
    >
      <div className="absolute top-1/2 -right-2 transform -translate-y-1/2 z-10">
        {/* <button
          onClick={() => setIsCollapsed((c) => !c)}
          className="p-1 rounded hover:bg-gray-100 bg-white shadow-sm border border-gray-200 mr-2"
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? (
            <FaAngleDoubleRight size={18} className="text-[#3B0069]" />
          ) : (
            <FaAngleDoubleLeft size={18} className="text-[#3B0069]" />
          )}
        </button> */}
      </div>
      <div style={styles.section} className="py-3 flex flex-col">
        {isOwner && (
          <MenuItem
            tab="Dashboard"
            label="Global Dashboard"
            Icon={PiSquareSplitVerticalFill}
            disabled={false}
          />
        )}
        <MenuItem
          tab="Lead Management"
          label="Lead Management"
          Icon={Users}
          disabled={!subscriptionName}
        />
        <MenuItem
          tab="Projects"
          label="Projects"
          Icon={MdFoundation}
          disabled={!subscriptionName}
        />
        <MenuItem
          tab="Design"
          label="Design"
          Icon={MdDescription}
          disabled={!subscriptionName}
        />
        <MenuItem
          tab="Procurement"
          label="Procurement"
          Icon={MdOutlineInventory2}
          disabled={!subscriptionName}
        />

        <MenuItem
          tab="Vendor"
          label="Vendor"
          Icon={MdOutlineShoppingCart}
          disabled={!subscriptionName}
        />

        <MenuItem
          tab="Contractor"
          label="Contractor"
          Icon={MdOutlinePeopleAlt}
          disabled={!subscriptionName}
        />

        <MenuItem
          tab="Finance"
          label="Finance"
          Icon={MdAccountBalanceWallet}
          disabled={!subscriptionName}
        />

        <MenuItem
          tab="Organization Team"
          label="Organization Team"
          Icon={MdDiversity3}
          disabled={!subscriptionName}
        />

        {/* <MenuItem
          tab="Document Manager"
          label="Document Manager"
          Icon={MdDescription}
          disabled={!isSubscribed}
        /> */}

        {/* <MenuItem
          tab="Quotation Generator"
          label="Quotation Generator"
          Icon={MdDescription}
          disabled={!isSubscribed}
        /> */}
      </div>

      <div style={styles.section} className="py-3 flex flex-col">
        <div
          style={styles.menuItem}
          className={`relative mx-2 ${currentTab === "Settings"
            ? "rounded-lg bg-fuchsia-100"
            : "hover:bg-gray-100 hover:rounded-lg"
            } ${isCollapsed ? "px-0 justify-center" : "px-3"}`}
          title={isCollapsed ? "Settings" : undefined}
          onClick={() => {
            // setIsSettingsOpen(true);
            setCurrentTab("Settings");
          }}
        >
          <FaCog color="#3B0069" size={22} />
          {!isCollapsed && (
            <span style={{ fontSize: "14px", color: "black" }}>Settings</span>
          )}
        </div>

        {/* <div
          style={styles.menuItem}
          onClick={() => {
            setCurrentTab("Help");
          }}
          className={`relative mx-2 ${currentTab === "Help"
            ? "rounded-lg bg-fuchsia-100"
            : "hover:bg-gray-100 hover:rounded-lg"
            } ${isCollapsed ? "px-0 justify-center" : "px-3"}`}
          title={isCollapsed ? "Help Center" : undefined}
        >
          <MdHelp color="#3B0069" size={22} />
          {!isCollapsed && (
            <span style={{ fontSize: "14px", color: "black" }}>
              Help Center
            </span>
          )}
        </div> */}
        {isOwner && (
          <div
            style={styles.menuItem}
            onClick={() => {
              setCurrentTab("Raise Request");
            }}
            className={`px-3 relative mx-2 ${currentTab === "Raise Request"
              ? "rounded-lg bg-fuchsia-100"
              : "hover:bg-gray-100 hover:rounded-lg"
              } ${isCollapsed ? "justify-center" : "gap-2"}`}
            title="Raise Support Ticket"
          >
            <MdOutlineSupportAgent color="#3B0069" size={22} />
            {!isCollapsed && (
              <span style={{ fontSize: "14px", color: "black" }}>
                Raise Support Ticket
              </span>
            )}
          </div>
        )}
        {isOwner && !isCollapsed && (
          <div
            className="p-2 pr-1 mx-3 rounded-xl flex flex-row items-center border-[1px] border-[#3B0069] bg-[#ECE6F0] mt-4 cursor-pointer"
            onClick={() => {
              if (subscriptionName !== "Premium Yearly Plan") {
                navigate("/subscription");
              }
            }}
            title="Your Plan"
          >
            <img
              src={Microinteraction}
              alt="spin"
              className="h-8 w-8 animate-spin-pause"
            />
            <div className="flex flex-col ml-2">
              {/* <span className="text-[#3B0069] text-xs font-normal">
                Your Plan
              </span> */}
              <span className="text-[#3B0069] text-base font-medium">
                {subscriptionName ? `SiteMaster` : ""}
              </span>
              <span className="text-[#3B0069] text-xs font-medium">
                {subscriptionName ? ` ${subscriptionName}` : "No Subscription"}
              </span>
            </div>
          </div>
        )}
      </div>
      {userData?.user && (
        <AccountModal
          isOpen={isSettingsOpen && userData?.user}
          onClose={() => setIsSettingsOpen(false)}
          userData={userData}
          handleLogOut={handleLogout}
          refetch={getUserDetails}
        />
      )}
    </div>
  );
};

const styles = {
  addMemberButton: {
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 8px",
    borderRadius: "10px",
    flexDirection: "row",
    gap: "10px",
    marginTop: "10px",
    border: "1px solid #3B0069",
    backgroundColor: "#FFFFFF",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "10px",
    height: "40px",
    cursor: "pointer",
    paddingLeft: "8px",
    transition: "background-color 0.2s ease",
  },
  sidebar: {
    width: "220px",
    overflowY: "auto",
    // position: "absolute",
    scrollbarWidth: "none",
    height: "100%",
    left: "0",
    padding: "-2px",
    backgroundColor: "#FFFFFF",
    // Removed boxShadow property to eliminate the black line
  },
  section: {
    // marginBottom: "40px",
    gap: "6px",
  },
  sectionTitle: {
    fontSize: "12px",
    fontWeight: 500,
    marginBottom: "0px",
    marginLeft: "14px",
    marginTop: "20px",
  },
  list: {
    listStyleType: "none",
    padding: "0",
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    fontSize: "16px",
    marginBottom: "20px",
    cursor: "pointer",
    marginLeft: "10px",
    fontWeight: "500",
    color: "#000000",
  },
  icon: {
    width: "20px",
    height: "20px",
    marginRight: "10px",
    verticalAlign: "middle",
    marginTop: "4px",
  },
};

export default LeftSidebar;
